<template>
  <div>
    <table>
      <tr v-for="item in specialList" :key="item.value">
        <td>
          <el-checkbox v-model='item.checked' style="margin: 0 0 0 20px;">{{item.label}}</el-checkbox>
        </td>
        <td v-if="item.checked">
          <el-checkbox v-model='item.isShow' style="margin: 0 0 0 40px;">设为外展用户</el-checkbox>
        </td>
      </tr>
      <tr>
        <el-switch v-model="isPass" style="margin: 0 0 0 20px; " active-text="通过简历"></el-switch>
      </tr>
    </table>
    <div class="dialog-footer" style="margin-bottom: 8px;">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="summit" v-loading="loading">确定</el-button>
    </div>
  </div>
</template>

<script>
import { getFormData, postFormData} from "@/api/api";
import {addUserSpecials, updateResumeState} from "@/api/url";
export default {
name: "SpecialDialog",
  props: {
    value: Object,
  },
  data() {
    return {
      specialList: this.value.specialList,
      idArray: this.value.idArray,
      loading: false,
      isPass: true,
    }
  },
  methods: {
    cancel() {
      this.$emit("close");
    },

    summit() {
      let _this = this;
      this.loading = true;
      let param = {};
      let cArr = [];
      let sArr = [];
      this.specialList.forEach((e) => {
        if(e['checked']) {
          cArr.push(e['value']);
        }
        if(e['isShow']) {
          sArr.push(e['value'])
        }
      });
      param['idArr'] = this.idArray;
      param['specialsIdArr'] = cArr;
      param['specialsIdShowList'] = sArr;
      postFormData(addUserSpecials, param).then(function(data) {
        let {
          code,
          msg
        } = data;
        if(code == 200) {
          _this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'success'
          });
          if(_this.isPass) {
            _this.batchPass()
          }
          _this.loading = false;
          _this.$emit('confirm')
        } else {
          _this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          });
          _this.$emit('close')
        }
      })
          .catch(function(response) {
            _this.loading = false;
          })
    },

    //更新简历状态
    batchPass() {
      let _this = this;
      let param = {};
      param['idArr'] = this.idArray;
      param['state'] = 2;
      param['warnMsg'] = '';
      param['warnTab'] = 0;
      postFormData(updateResumeState, param).then((data) => {
        let {code, msg} = data;
        if(code == 200) {
          _this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'success'
          });
        }else {
          _this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          });
        }
      })
          .catch(()=>{
          })
    },


  },
  mounted() {
    this.specialList.map(e => {
      e.checked = false
      e.isShow = false
    })
  }
}
</script>

<style scoped>

</style>
